import React, { Fragment } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function ComparisonTable() {
  const comparisons = [{
    source: 'News Articles',
    reason: 'Written in 4 hours. Optimized for outrage, not understanding.'
  }, {
    source: 'Social Media Threads',
    reason: 'Fragmented, emotionally driven, missing context.'
  }, {
    source: 'Opinion Columns',
    reason: 'One perspective. Heavy on feeling, light on fact.'
  }, {
    source: 'YouTube Documentaries',
    reason: 'Still in production. Months away. Already filtered.'
  }, {
    source: 'Nothing',
    reason: 'The default choice. The one that lets the story disappear.',
    isDefault: true
  }];
  return <section className="py-20 md:py-28 px-6 bg-base" data-id="element-115">
      <div className="max-w-4xl mx-auto" data-id="element-116">
        {/* Section label */}
        <FadeIn data-id="element-117">
          <div className="flex items-center gap-4 mb-16" data-id="element-118">
            <div className="h-px bg-border-accent flex-grow" data-id="element-119" />
            <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-120">
              ◆ The Alternatives ◆
            </span>
            <div className="h-px bg-border-accent flex-grow" data-id="element-121" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-122">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-text-primary mb-6 text-center leading-tight" data-id="element-123">
            Why Everything Else Falls Short
          </h2>
          <p className="font-body text-lg text-text-secondary text-center mb-16 max-w-xl mx-auto" data-id="element-124">
            We looked at what's available. Here's what we found.
          </p>
        </FadeIn>

        {/* Comparison rows */}
        <div className="space-y-3" data-id="element-125">
          {comparisons.map((item, index) => <FadeIn key={index} delay={0.15 + index * 0.06} data-id="element-126">
              <div className={`grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-0 rounded-sm overflow-hidden transition-colors duration-250 ${item.isDefault ? 'bg-elevated border border-accent-primary/30' : 'bg-surface border border-border-default hover:border-border-accent'}`} data-id="element-127">
                {/* Source */}
                <div className="md:col-span-4 p-5 md:p-6 flex items-start gap-3" data-id="element-128">
                  <span className={`mt-0.5 flex-shrink-0 font-mono text-sm ${item.isDefault ? 'text-accent-primary' : 'text-text-muted'}`} data-id="element-129">
                    ✕
                  </span>
                  <span className={`font-display text-lg font-bold ${item.isDefault ? 'text-accent-primary' : 'text-text-primary'}`} data-id="element-130">
                    {item.source}
                  </span>
                </div>
                {/* Reason */}
                <div className="md:col-span-8 p-5 md:p-6 md:border-l border-border-default flex items-center" data-id="element-131">
                  <p className={`font-body text-base leading-relaxed ${item.isDefault ? 'text-text-primary italic' : 'text-text-secondary'}`} data-id="element-132">
                    {item.reason}
                  </p>
                </div>
              </div>
            </FadeIn>)}

          {/* THIS BOOK — the answer */}
          <FadeIn delay={0.5} data-id="element-133">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-0 rounded-sm overflow-hidden bg-elevated border-2 border-accent-primary mt-6 shadow-gold-subtle" data-id="element-134">
              {/* Source */}
              <div className="md:col-span-4 p-5 md:p-6 flex items-start gap-3" data-id="element-135">
                <span className="mt-0.5 flex-shrink-0 font-mono text-sm text-accent-primary" data-id="element-136">
                  ◆
                </span>
                <span className="font-display text-lg font-bold text-accent-primary" data-id="element-137">
                  This Book
                </span>
              </div>
              {/* Reason */}
              <div className="md:col-span-8 p-5 md:p-6 md:border-l border-accent-primary/30 flex items-center" data-id="element-138">
                <p className="font-body text-base text-text-primary leading-relaxed font-medium" data-id="element-139">
                  170 pages. Editorially crafted. The complete account — causes,
                  consequences, and meaning — in one document.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Closing line */}
        <FadeIn delay={0.6} data-id="element-140">
          <div className="border-l-4 border-accent-primary bg-surface p-6 md:p-8 mt-14" data-id="element-141">
            <p className="font-display text-xl md:text-2xl italic text-text-primary leading-relaxed m-0" data-id="element-142">
              There is no editorial-grade document that covers the full scope of
              what happened — its causes, its consequences, and its meaning —{' '}
              <span className="text-accent-primary not-italic font-bold" data-id="element-143">
                until now.
              </span>
            </p>
          </div>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.7} data-id="element-144">
          <div className="flex flex-col items-center mt-12 text-center" data-id="element-145">
            <Button href="#offer" variant="secondary" className="w-full md:w-auto text-sm md:text-base" data-id="element-146">
              See The Full Memorial Edition &rarr;
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}